import { Tag, Plus } from "lucide-react";

import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { EmptyState } from "@/components/shared/EmptyState";
import CategoriaTableRow from "./CategoriaTableRow";

const COLUMNS = [
  { id: "name",   label: "Categoria", align: "text-left" },
  { id: "total",  label: "Total",     align: "text-left" },
  { id: "delta",  label: "Δ vs anterior", align: "text-left" },
  { id: "pct",    label: "%",         align: "text-left" },
  { id: "count",  label: "Compras",   align: "text-left" },
  { id: "more",   label: "",          align: "text-right" },
];

export default function CategoriaTable({
  rows,
  isLoading,
  onDrillDown,
  onEdit,
  onDelete,
  onCreate,
}) {
  if (!isLoading && rows.length === 0) {
    return (
      <Card variant="elevated" className="glass-card py-10 px-6 min-h-[420px] flex items-center" data-testid="cat-table-empty">
        <EmptyState
          icon={Tag}
          title="Sem categorias com despesas"
          description="Quando você registrar despesas, as categorias aparecem aqui com totais e variação mensal."
          action={onCreate ? (
            <Button variant="secondary" size="md" onClick={onCreate}>
              <Plus className="w-4 h-4" /> Nova categoria
            </Button>
          ) : null}
        />
      </Card>
    );
  }

  return (
    <>
      {/* MD+ table */}
      <Card variant="elevated" className="glass-card overflow-hidden hidden md:block min-h-[420px]" data-testid="cat-table">
        <div className="overflow-x-auto">
          <table className="w-full text-caption">
            <thead className="sticky top-0 z-10 bg-surface-overlay/95 backdrop-blur border-b border-subtle">
              <tr>
                {COLUMNS.map(c => (
                  <th
                    key={c.id}
                    className={`py-3 px-3 text-foreground-muted text-micro font-semibold uppercase ${c.align}`}
                    style={{ letterSpacing: "0.10em" }}
                  >
                    {c.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map(r => (
                <CategoriaTableRow
                  key={r.name}
                  row={r}
                  onDrillDown={onDrillDown}
                  onEdit={onEdit}
                  onDelete={onDelete}
                  variant="table"
                />
              ))}
            </tbody>
          </table>
        </div>
      </Card>

      {/* Mobile compact */}
      <div className="md:hidden flex flex-col gap-2.5" data-testid="cat-table-compact">
        {rows.map(r => (
          <CategoriaTableRow
            key={r.name}
            row={r}
            onDrillDown={onDrillDown}
            onEdit={onEdit}
            onDelete={onDelete}
            variant="compact"
          />
        ))}
      </div>
    </>
  );
}
